export const formatCoordinates = (lat, lng) => {
    if (!lat || !lng) return 'Coordenadas no disponibles';
    return `${Number(lat).toFixed(6)}, ${Number(lng).toFixed(6)}`;
};

export const getLocationTypeLabel = (type) => {
    const labels = {
        CASA_PRINCIPAL: 'Casa principal',
        CASA_SECUNDARIA: 'Casa secundaria',
        TRABAJO: 'Trabajo',
        OTRO: 'Otro',
    };
    return labels[type] || 'Otro';
};

export const isValidCoordinates = (lat, lng) => {
    return (
        typeof lat === 'number' &&
        typeof lng === 'number' &&
        lat >= -90 &&
        lat <= 90 &&
        lng >= -180 &&
        lng <= 180
    );
};